import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, Card, Col, Form, Row, Select, Spin,} from "antd";

import {getCompatibleSpares, getSubAssemblySpares} from "../../appRedux/actions/SparePart";
import {fetchRelationshipSearchData, getSpareInventoryFilters} from "../../appRedux/actions";

class SpareCompatibility extends Component {
  state = {
    selectedSparePart: ['All'],
  };
  componentDidMount = () => {
    this.props.getSpareInventoryFilters();
    this.fetchData();
  };

  fetchData = (spareId = null) => {
    console.log(`Fetching ....`, this.props.match.params);
    if(this.props.match.params.id)
      this.props.getCompatibleSpares(this.props.match.params.id);
    else if(spareId) {
      this.props.getCompatibleSpares(spareId);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.form.validateFields((err, values) => {
      if(err) {
      } else {
        const {
          selectedSparePart,
        } = this.state;
        this.fetchData(selectedSparePart)
      }
    });
  };

  handleSelect = (type, value) => {
    switch (type) {
      case 'sparePart':
        this.setState({
          selectedSparePart: value
        });
        break;
      default:
    }
  };

  fetchSpare = value => {
    if(value && value.length >= 2)
      this.props.fetchRelationshipSearchData(value, 'SparePart', 'name');
  };

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {loading, sparePartData, compatibleSpares} = this.props;
    console.log(compatibleSpares);
    return (
      <div>
        <Spin spinning={loading}>
          <Card
            className={`gx-card-metrics`}
            title={`Spare Compatibility Report`}
          >
            {!this.props.match.params.id ?
              (<Form
                onSubmit={this.handleSubmit}
                className="ant-advanced-search-form"
                layout="inline"
                labelAlign="left"
              >
                <Row gutter={8}>

                  <Col xs={24} sm={12} md={8} lg={7} xl={7}>

                    <Form.Item key={'sparePart'} label={'Enter Spare Part'} style={{width: '100%'}}>
                      {getFieldDecorator(`sparePart`, {
                        rules: [{required: true, message: `Spare Part is required!`}],
                        initialValue: null,
                      })(<Select
                        showSearch
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        onSearch={this.fetchSpare}
                        onChange={value => this.handleSelect('sparePart', value)}
                        placeholder={`Please Enter Spare Part`}
                      >
                        {(sparePartData || []).map(item =>
                          <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                      </Select>)
                      }
                    </Form.Item>

                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Form.Item key={`submit`}>
                      <Button type="primary" htmlType="submit" loading={loading}>
                        Get Compatibility
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>) : null}
          </Card>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = ({auth, commonData, sparePart}) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    sparePartData: commonData.relationshipSearch,
    compatibleSpares: sparePart.compatibleSpares,
    subAssemblySpares: sparePart.subAssemblySpares
  };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchRelationshipSearchData,
    getSpareInventoryFilters,
    getCompatibleSpares,
    getSubAssemblySpares
  };
}

const SpareCompatibilityReport = Form.create({name: 'spare-compatibility'})(SpareCompatibility);
export default connect(mapStateToProps, mapDispatchToProps())(SpareCompatibilityReport);
